import backgrounds from './colors/backgrounds'
import borders from './colors/borders'
import feedback from './colors/feedback'
import icons from './colors/icons'
import primary from './colors/primary'
import texts from './colors/texts'

const colors = { ...backgrounds, ...feedback, ...icons, ...primary, ...texts, ...borders }

export default colors
